var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoopOptimiseLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "81px",
    height: "45px",
    viewBox: "0 0 81 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 24.7280645 0 24.7280645 25.5800852 0 25.5800852"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 45 80.4759367 45 80.4759367 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Loop-Optimise",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Admin---Your-Optimisation",
    transform: "translate(-30, -68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(30, 68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5234031,19.9062923 C18.400183,23.1745287 14.8391297,24.865325 11.2900088,24.8984373 C7.73134198,24.9302363 8.68520404,20.6799777 6.61376979,17.2928963 C4.54686978,13.9134516 0.339089969,12.5359955 2.14586747,9.38684273 C3.95574736,6.23148516 7.28555405,3.92283828 11.2835653,3.92283828 C15.2818153,3.92283828 18.6070877,6.25272452 20.4575372,9.40020683 C22.3316124,12.5875428 22.6630897,16.6139527 20.5234031,19.9070082 L20.5234031,19.9062923 Z M11.3095776,0 C7.04834142,0 3.49826585,5.65110174 1.56858643,9.01956885 C-0.35727468,12.3815926 -0.669660329,16.6428287 1.53398298,20.2508949 C3.74263782,23.8675523 7.52300533,25.6139527 11.3164983,25.5795879 C15.0992522,25.5449845 21.665317,25.1206746 23.9286214,21.631692 C26.2091083,18.1159812 23.0873996,12.4364808 21.0887519,9.03293294 C19.1161165,5.67305704 15.5393127,0 11.3095776,0 Z",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.1886246,19.2860313 C54.6456288,19.2860313 52.5978204,17.1919259 52.5978204,14.649646 C52.5978204,12.1076048 54.6456288,10.0368865 57.1886246,10.0368865 C59.7316204,10.0368865 61.7794288,12.083979 61.7794288,14.6262588 C61.7794288,17.1683001 59.7550076,19.2860313 57.1886246,19.2860313 L57.1886246,19.2860313 Z M57.1886246,7.80102617 C53.4216212,7.80102617 50.1488505,10.7425583 50.1488505,14.5785299 C50.1488505,18.414263 53.3512211,21.5211757 57.1886246,21.5211757 C61.0260282,21.5211757 64.2283987,18.3438629 64.2283987,14.6255429 C64.2283987,10.9069843 61.002641,7.80031024 57.1886246,7.80031024 L57.1886246,7.80102617 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "31.5879405 21.1921088 34.0369103 21.1921088 34.0369103 3.77702649 31.5879405 3.77702649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0851245,19.2860313 C69.4951157,19.2860313 67.6587463,17.1675841 67.6587463,14.649646 C67.6587463,12.1319465 69.4951157,10.0368865 72.0147244,10.0368865 C74.5340943,10.0368865 76.4881155,12.2257338 76.4881155,14.696659 C76.4881155,17.1675841 74.6515074,19.2860313 72.0851245,19.2860313 Z M72.1791504,7.80102617 C70.3191552,7.80102617 68.624302,8.60143982 67.5413332,10.1542996 L67.4943203,10.1542996 L67.4943203,8.15422003 L65.2575054,8.15422003 L65.2575054,25.5459152 L67.7064752,25.5459152 L67.7064752,19.3094185 L67.7534882,19.3094185 C68.6956567,20.8625169 70.6026649,21.5218917 72.3442924,21.5218917 C76.0879087,21.5218917 78.9370854,18.5333466 78.9370854,14.8384138 C78.9370854,10.9086548 76.2060377,7.8017421 72.1798664,7.8017421 L72.1791504,7.80102617 Z",
    id: "Fill-8",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2521995,19.2860313 C39.7092037,19.2860313 37.6613953,17.1919259 37.6613953,14.649646 C37.6613953,12.1076048 39.7092037,10.0368865 42.2521995,10.0368865 C44.7951953,10.0368865 46.8430037,12.083979 46.8430037,14.6262588 C46.8430037,17.1683001 44.8185825,19.2860313 42.2521995,19.2860313 L42.2521995,19.2860313 Z M42.2521995,7.80102617 C38.4851961,7.80102617 35.2124254,10.7425583 35.2124254,14.5785299 C35.2124254,18.414263 38.414796,21.5211757 42.2521995,21.5211757 C46.0896031,21.5211757 49.2919736,18.3438629 49.2919736,14.6255429 C49.2919736,10.9069843 46.0662159,7.80031024 42.2521995,7.80031024 L42.2521995,7.80102617 Z",
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "79.0544746 20.6205314 79.0544746 21.3660568 79.1945589 21.3660568 79.1945589 20.6205314 79.433442 20.6205314 79.433442 20.5086071 79.0091321 20.5086071 79.0091321 20.6205314"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "80.033442 21.1961658 79.7547053 20.5217564 79.5869382 20.5217564 79.5869382 21.3660807 79.7255906 21.3660807 79.7255906 20.7334341 79.9706785 21.3660807 80.0921486 21.3660807 80.3358046 20.7334341 80.3358046 21.3660807 80.475889 21.3660807 80.475889 20.5217564 80.3083605 20.5217564"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "78.8171188 20.6205552 79.0097049 20.6205552 79.0097049 20.508631 78.8171188 20.508631"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.68125845,33.0251054 C3.68316761,33.0251054 1.26784663,35.5604646 1.26784663,38.5072468 C1.26784663,41.3681171 3.75189722,43.8521677 6.69844086,43.8521677 C9.73065786,43.8521677 12.1462175,41.3681171 12.1462175,38.4556996 C12.1462175,35.5263384 9.73065786,33.0251054 6.68125845,33.0251054 M6.69844086,45.0000477 C3.23785697,45.0000477 -7.15933498e-05,42.190486 -7.15933498e-05,38.5072468 C-7.15933498e-05,34.8581338 2.98083685,31.8772254 6.69844086,31.8772254 C10.3816801,31.8772254 13.4138971,34.8240076 13.4138971,38.4385172 C13.4138971,42.0191393 10.3816801,45.0000477 6.69844086,45.0000477",
    id: "Fill-13",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5566462,38.5242145 C22.3211837,38.5242145 23.5719195,37.4622464 23.5719195,35.8859995 C23.5719195,34.6183199 22.766733,33.2477846 20.2826824,33.2477846 L17.7299022,33.2477846 L17.7299022,38.5242145 L20.5566462,38.5242145 Z M16.4622226,44.7771776 L16.4622226,32.0999045 L20.2996261,32.0999045 C23.7945748,32.0999045 24.8395991,34.1730093 24.8395991,35.9203643 C24.8395991,37.6164108 23.7430276,39.6720945 20.2826824,39.6720945 L17.7299022,39.6720945 L17.7299022,44.7771776 L16.4622226,44.7771776 Z",
    id: "Fill-14",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "29.3616021 44.7772492 29.3616021 33.2478562 26.4491846 33.2478562 26.4491846 32.0999761 33.5245167 32.0999761 33.5245167 33.2478562 30.6292817 33.2478562 30.6292817 44.7772492"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "35.9737491 44.7773447 37.2414287 44.7773447 37.2414287 32.1000716 35.9737491 32.1000716"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "52.7451118 44.7772492 52.7451118 33.4876939 52.7109856 33.4876939 47.9655397 44.7772492 46.8861507 44.7772492 42.1750696 33.4876939 42.1407048 33.4876939 42.1407048 44.7772492 40.8730252 44.7772492 40.8730252 32.0999761 42.8260918 32.0999761 47.4343171 42.8929123 52.0599634 32.0999761 54.01303 32.0999761 54.01303 44.7772492"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "57.6438629 44.7773447 58.9115424 44.7773447 58.9115424 32.1000716 57.6438629 32.1000716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7681887,35.3207223 C67.7681887,34.0186779 66.705982,33.0252009 65.5239758,33.0252009 C64.2219314,33.0252009 63.2282157,34.0014955 63.2282157,35.2350489 C63.2282157,36.314438 63.8792379,36.9824039 65.6779015,37.444897 C68.4189722,38.1474664 69.344197,39.5693103 69.344197,41.2823005 C69.344197,43.3554053 67.6481505,44.9999045 65.5239758,44.9999045 C63.2797629,44.9999045 61.6522075,43.4923872 61.6178427,41.230992 L62.8857609,41.230992 C62.9714343,42.8585475 63.9990375,43.8522631 65.5239758,43.8522631 C66.9630021,43.8522631 68.0762787,42.7213269 68.0762787,41.3338477 C68.0762787,39.9633124 67.1684751,39.1924907 65.5067934,38.7128152 C63.6907088,38.198775 61.9605362,37.5990613 61.9605362,35.2863575 C61.9605362,33.2819823 63.5709092,31.8773208 65.5239758,31.8773208 C67.4939862,31.8773208 69.0358683,33.3676557 69.0358683,35.3207223 L67.7681887,35.3207223 Z",
    id: "Fill-19",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-4)",
    points: "71.9988784 44.7772492 71.9988784 32.0999761 78.9369899 32.0999761 78.9369899 33.2478562 73.266558 33.2478562 73.266558 37.8047729 78.7486994 37.8047729 78.7486994 38.9526529 73.266558 38.9526529 73.266558 43.6293692 78.9369899 43.6293692 78.9369899 44.7772492"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopOptimiseLogoMobile);
export default __webpack_public_path__ + "static/media/loop-optimise-logo-mobile.987b701f0b053b7992dd418d95ba8230.svg";
export { ForwardRef as ReactComponent };